<div class="notebook-sidebar">
  <div class="notebook-type-select">
    <mode-radio-dropdown
      [dropdownData]="LANGUAGES"
      [selectedValue]="notebookType"
      (dropdownChange)="changeNotebookType($event)"
    >
    </mode-radio-dropdown>
  </div>

  <div class="notebook-sidebar-container">
    <ul class="sidebar-tabs">
      <li [ngClass]="{ active: activeTab === 'resources' }">
        <a href="javascript:void(0)" (click)="goToTab('resources')" role="button">Resources</a>
      </li>
      <li
        [ngClass]="{ active: activeTab === 'secrets' }"
        *ngIf="notebookType !== 'r' && isRegisterSecureCredentialsEnabled"
      >
        <a href="javascript:void(0)" (click)="goToTab('secrets')" role="button">Secrets</a>
      </li>
      <li [ngClass]="{ active: activeTab === 'help' }">
        <a href="javascript:void(0)" (click)="goToTab('help')" role="button">Help</a>
      </li>
    </ul>

    <!-- Supported Libraries -->
    <div *ngIf="activeTab === 'resources'" class="sub-container">
      <mode-notebook-supported-libraries
        [environment]="notebookType"
        [state]="itemExpandedOrCollapsed"
        (sectionToggle)="toggle($event)"
      >
      </mode-notebook-supported-libraries>
    </div>

    <!-- Notebook Secrets -->
    <div
      *ngIf="activeTab === 'secrets' && notebookType !== 'r' && isRegisterSecureCredentialsEnabled"
      class="sub-container"
    >
      <mode-notebook-secrets></mode-notebook-secrets>
    </div>

    <!-- Help -->
    <div *ngIf="activeTab === 'help'" class="sub-container" #helpContainer>
      <!-- Python -->
      <ul *ngIf="notebookType !== 'r'" class="collapsible-list">
        <mode-python-intro
          [itemExpandedOrCollapsed]="itemExpandedOrCollapsed"
          (toggle)="toggle($event)"
          (goToSupportedLibraries)="goToSupportedLibraries()"
          (goToKeyboardShortcuts)="goToKeyboardShortcuts()"
        ></mode-python-intro>
        <mode-keyboard-shortcuts
          [itemExpandedOrCollapsed]="itemExpandedOrCollapsed"
          (toggle)="toggle($event)"
        ></mode-keyboard-shortcuts>
      </ul>
      <!-- R -->
      <ul *ngIf="notebookType === 'r'" class="collapsible-list">
        <mode-r-intro
          [itemExpandedOrCollapsed]="itemExpandedOrCollapsed"
          (toggle)="toggle($event)"
          (goToSupportedLibraries)="goToSupportedLibraries()"
          (goToKeyboardShortcuts)="goToKeyboardShortcuts()"
        ></mode-r-intro>
        <mode-keyboard-shortcuts
          [itemExpandedOrCollapsed]="itemExpandedOrCollapsed"
          (toggle)="toggle($event)"
        ></mode-keyboard-shortcuts>
      </ul>
    </div>
  </div>
</div>
